import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../../../../Utilities/Functions";
import LineChart from "../../../../../Component/Charts/Line";
import config from "../config";

const { chartColors } = config;

const ChecksTimeline = (props) => {
  const { data } = props;

  const [series, setSeries] = useState([]);
  const [categories, setCategories] = useState([]);

  const { t } = useTranslation();

  const dataSeries = [
    {
      name: t("labels.dashboard.checkTimeline.kycCheck"),
      data: [],
      color: chartColors.checkColors.kyc,
    },
    {
      name: t("labels.dashboard.checkTimeline.amlCheck"),
      data: [],
      color: chartColors.checkColors.aml,
    },
    {
      name: t("labels.dashboard.checkTimeline.totalCheck"),
      data: [],
      color: chartColors.checkColors.total,
    },
  ];

  useEffect(() => {
    dataSeries[0].data = [];
    dataSeries[1].data = [];
    dataSeries[2].data = [];

    let xValues = [];

    const grouped = (data || []).reduce(function (ds, r) {
      const xValue = formatDate(r.check_date, false);
      // xValues.push(xValue);
      const series = r.check_type;
      if (!ds[xValue]) {
        ds[xValue] = {};
      }
      ds[xValue][series] = r.no_of_checks;
      return ds;
    }, {});

    xValues = Object.keys(grouped).map((item) => item);

    xValues = xValues.sort(function (a, b) {
      a = a.split("/").reverse().join("");
      b = b.split("/").reverse().join("");
      return a.localeCompare(b);
    });

    xValues.forEach((x) => {
      const data = grouped[x];
      dataSeries[0].data.push(data["KYC"]);
      dataSeries[1].data.push(data["AML"]);
      dataSeries[2].data.push((data["KYC"] || 0) + (data["AML"] || 0));
    });

    setSeries([...dataSeries]);
    setCategories(xValues);
  }, [data]);

  const handleIntervals = (index, _) => {
    const n = categories.length;
    const noOfItemsToShow = 2;

    const intervalFactor = parseInt(n / noOfItemsToShow);

    if ((index + 1) % intervalFactor === 0) return true;

    return false;
  };

  return (
    <LineChart
      series={series}
      categories={categories}
      title={t("labels.dashboard.checkTimeline.title")}
      handleIntervals={handleIntervals}
    />
  );
};

export default ChecksTimeline;
